query BrandForBrandsConsole(
    $id: ID!
) {
    brand(
        id: $id
    ) {
        id

        name
        logo
        color

        about {
            language
            text
        }
        address {
            street
            city
            zipCode
            country
        }
        coverImage
        url

        alternativeNames
        features
        primaryLanguage
        enableCatalog

        legacyAlias
        legacyID

        arbitraryData
    }
}
